import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { numbersTabs } from '../../shared/numbersTabs';

export default function NumberPools(props) {
    const data = {
        url: '/admin/numbers/pools',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/numbers/pools/{id}',
        userfilter: [
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'status',
                label: 'Status',
                type: 'select',
                default: ''
            },
            {
                source: 'type',
                label: 'Type',
                type: 'select',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Pool name'
            },
            {
                label: 'Description',
                source: 'description',
                type: 'text',
                editable: false,
                default: '',
                placeholder: 'Description'
            },
            {
                label: 'Type',
                source: 'type',
                type: 'select',
                editable: false,
                default: '',
                values: {
                    'shared': 'Shared',
                    'dedicated': 'Dedicated',
                    'reserved': 'Reserved'
                },
                classnames: {
                    'shared': 'label label-info',
                    'dedicated': 'label label-success',
                    'reserved': 'label label-warning'
                }
            },
            {
                label: 'Capacity',
                source: 'capacity',
                type: 'number',
                editable: false,
                default: 0,
                placeholder: '0'
            },
            {
                label: 'Used',
                source: 'used_count',
                type: 'number',
                editable: false,
                default: 0,
                placeholder: '0'
            },
            {
                label: 'Available',
                source: 'available_count',
                type: 'number',
                editable: false,
                default: 0,
                placeholder: '0'
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'Active',
                    false: 'Inactive'
                },
                classnames: {
                    true: 'label label-success',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                default: ''
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="Number Pools">
            <>            
                <Tabs tabs={numbersTabs} />
                <DataResource
                    addButtonText="Create New Pool"
                    addButtonType="link"
                    addButtonLink="/numbers/pools/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}
